var _image;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEdit({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _image || (_image = /*#__PURE__*/React.createElement("image", {
    id: "icono_editar",
    "data-name": "icono editar",
    width: 18,
    height: 18,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIAAAAyCAYAAAAeP4ixAAAABmJLR0QA/wD/AP+gvaeTAAAC+klEQVRoge3Yv08TYRzH8ff3+BHi4KB3DC36Lzg5i4pxcnRWQITww2CvMQwOuJiIUDQGEBB3/wA3YoyzMU4mrnpXI0UHXSDCfR30SDm40kJ79zThMz3X53vt95Xn7unl4DhmRdJu4KCcdr+dbyG4r8gF0HbgI8rTUiH7qrzOaIjjejfAWgZt22f6WWkmeyc8sBLsq7ZMaisiozEIgDEn510PDwyGyNbmdnAV5UN8kYyFI+Mgdr444Li+b+e8i79mz/zc1OBKLEY4Fw6NgnS63pCoLgIZLE4AVMQIm+HQGEin6w0pMg+Iitxdn+56Hc7FY/RdODICsheReRKt2YuRPyrWw3A+dUg1iDA7GOE9BAPrjzMVNoIE0+l6Q47rB47rq50vjleqtfP+NTv/tRv4tzVHsueDpGLnvMFqV8LOF8dFdRasIpBlUraiNalcWnbOGxSRBWpCoIo8iKtLfEVst3hL0HlAECaqRaCMrRcyS3G1iT5r/UcsAhbCRGk6+yi2NoIoFbJzlb47MYiT9/tRlmgAAhKCNBoBCUCSQECDIUkhAFqO2mxcDosQGC0VsvO1/l5DVuQoiLWZ2hHQAEgaCKgzJC0E1PEecXJ+H7BMCgio04o4Ob8PSQ8BdYCYgIAjQkxBwBEgJiHgkBDTEHAIiIkIqBFiKgJqgBwaoTqyVuhaqEezlVIVxHQEVAFpBgQcAGkWBFR41nLyfi/wgiZAQMyKOHm/F20eBOwDcXLeTURWAKuGl2cBwu3SdHalkc1Wyi7IqbEfJ1vaN74DHc2EgMgrU6ttoxvoANTSYCPupN1/djqSNgIiEIHL4VCR+U7XG4qeEEEMr810PU+i0YOyGyL0lB9GMaYioOwese99ych2i8feDUAFHQ7E6jAVAWVv460tq0dl3+1YFJkTVQsIUAbWCl0vk2uxuuxcWsHuy2q/uk1U+0uFrHEIKFsRQS5FJwU+qbKqFqtY7W/Xp5zfybZXfcogfFZA0TeWshq0BqulqbPFFHs7TlPnL3yMX7X8MQbqAAAAAElFTkSuQmCC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.169f65532c8e7d3b69f59fa04aa5a469.svg";
export { ForwardRef as ReactComponent };